import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {CasinoBetsService} from "../services/casino/casino-bets.service";
import {CasinoDTennPattiPopupComponent} from "../modals/casino-result-details/teen-patti20/details.component";
import {CasinoDLuckyPopupComponent} from '../modals/casino-result-details/lucky7/details.component';
import {CasinoDragonTigerPopupComponent} from "../modals/casino-result-details/dragontiger/details.component";
import {CasinoDragonTigerLionPopupComponent} from "../modals/casino-result-details/dragontigerlion/details.component";
import {CasinoAaaPopupComponent} from "../modals/casino-result-details/aaa/details.component";
import {CasinoDTennPattiOneDayPopupComponent} from "../modals/casino-result-details/teen-pattioneday/details.component";
import {CasinoDTennPattiTestPopupComponent} from "../modals/casino-result-details/teen-pattitest/details.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {PokerOnedayResultComponent} from "../modals/casino-result-details/poker-oneday/poker-oneday.component";
import {CasinoDPoker20PopupComponent} from "../modals/casino-result-details/poker20/details.component";
import { Poker6playerResultComponent } from '../modals/casino-result-details/poker6player/poker6player.component';
import { Baccarat1ResultComponent } from '../modals/casino-result-details/baccarat1/baccarat1.component';
import { Baccarat2ResultComponent } from '../modals/casino-result-details/baccarat2/baccarat2.component';
import { CasinoTennPattiOpenPopupComponent } from '../modals/casino-result-details/teen-pattiopen/details.component';
import { CasinoDAndarBaharPopupComponent } from '../modals/casino-result-details/andarbahar/details.component';
import { CasinoDCardTreeTwoAPopupComponent } from '../modals/casino-result-details/card32a/details.component';
import { CasinoDCardTreeTwoBPopupComponent } from '../modals/casino-result-details/card32b/details.component';
import { Andarbahar2ResultComponent } from '../modals/casino-result-details/andarbahar2-result/andarbahar2-result.component';

@Component({
    selector: 'app-casino-results',
    templateUrl: './casino-results.component.html',
    styleUrls: ['./casino-results.component.css']
})
export class CasinoResultsComponent implements OnInit {
    casinoFilterForm: any;
    submitted = false;
    casinoFilteredData: any = [];
    games: any = [{name: 'Teen Patti T20', value: 'teen20'},
        {name: 'Teenpatti 1-day', value: 'teen'},
        {name: 'Teenpatti Test', value: 'teen9'},
        {name: 'Teenpatti Open', value: 'teen8'},
        {name: 'Dragon Tiger- 20-20', value: 'dt20'},
        {name: '20-20 Dragon Tiger 2', value: 'dt202'},
        {name: '20-20 D T L', value: 'dtl20'},
        {name: '1 Day Dragon Tiger', value: 'dt6'},
        {name: 'Andar Bahar', value: 'ab20'},
        {name: 'Andar Bahar 2', value: 'abj'},
        {name: 'Amar Akbar Anthony', value: 'aaa'},
        {name: 'Lucky 7 A	', value: 'lucky7'},
        {name: 'Lucky 7 B	', value: 'lucky7eu'},
        {name: '32card A', value: 'card32'},
        {name: '32card B', value: 'card32eu'},
        {name: 'Poker 1 Day', value: 'poker'},
        {name: '20-20 Poker', value: 'poker20'},
        {name: 'Poker 6 Player', value: 'poker9'},
        {name: 'Baccarat 1', value: 'baccarat'},
        {name: 'Baccarat 2', value: 'baccarat2'},
    ]

    constructor(private fb: FormBuilder, private casinoBetService: CasinoBetsService, public dialog: MatDialog) {
        this.casinoFilterForm = this.fb.group({
            game_name: ['', Validators.required],
            f_date: [this.formatDate(new Date()), Validators.required]
        });
    }

    
  formatDate(date: Date): string {
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);  // Months are zero-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;  // Format as yyyy-MM-dd
  }

    ngOnInit(): void {

    }

    get casinoFilterFormControl() {
        return this.casinoFilterForm.controls;
    }

    search() {
        if (this.casinoFilterForm.invalid) {
            return;
        } else {
            this.submitted = true;
            let filter = {...this.casinoFilterForm.value}
            this.casinoBetService.getCasinoResultsInDB(filter).subscribe((data: any) => {
                this.casinoFilteredData = data;
            })
        }
    }

    openCasinoDetails(data: any) {
        console.log('data',data);
        let component: any = CasinoDTennPattiPopupComponent;
        if (data.gtype == "teen20") {
            component = CasinoDTennPattiPopupComponent;
        } else if (data.gtype == "teen") {
            component = CasinoDTennPattiOneDayPopupComponent
        } else if (data.gtype == "teen9") {
            component = CasinoDTennPattiTestPopupComponent
        }else if (data.gtype == "teen8") {
            component = CasinoTennPattiOpenPopupComponent
        }
         else if (data.gtype == "lucky7" || data.gtype == "lucky7eu") {
            component = CasinoDLuckyPopupComponent
        } else if (data.gtype == "dt20" || data.gtype == "dt202" || data.gtype == "dt6") {
            component = CasinoDragonTigerPopupComponent
        } else if (data.gtype == "aaa") {
            component = CasinoAaaPopupComponent
        } else if (data.gtype == "dtl20") {
            component = CasinoDragonTigerLionPopupComponent
        } 
         else if (data.gtype == "ab20") {
            component = CasinoDAndarBaharPopupComponent
        } else if (data.gtype == "abj") {
            component = Andarbahar2ResultComponent
        } 
         else if (data.gtype == "card32") {
            component = CasinoDCardTreeTwoAPopupComponent
        } else if (data.gtype == "card32eu") {
            component = CasinoDCardTreeTwoBPopupComponent
        } 
        else if (data.gtype == "poker") {
            component = PokerOnedayResultComponent
        } else if (data.gtype == "poker20") {
            component = CasinoDPoker20PopupComponent
        } else if (data.gtype == "poker9") {
            component = Poker6playerResultComponent
        }else if(data.gtype=="baccarat"){
            component = Baccarat1ResultComponent
        }else if(data.gtype=="baccarat2"){
            component = Baccarat2ResultComponent
        }
        const dialogRef = this.dialog.open(component, {
            autoFocus: false,
            maxHeight: '100vh',
            maxWidth: '100vh',
            width: '100vh',
            position: {top: '50px'},
            data: {
                mid: data.mid,
                gamename: data.gtype,
                stored_data:data
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
        });

    }

    getFullName(name:any):string {
        let result = '';
        switch (name) {
          case 'T':
            result =  'TIGER';
            break;
          case 'L':
            result =  'LION';
            break;
          case 'D':
            result = 'DRAGON';
            break;
        }
        return result;
      }
}
